import PropTypes from 'prop-types';
import React from 'react';
import AvatarNamed from 'components/AvatarNamed';
import Link from 'components/Link';
import {FormattedMessage, FormattedDate} from 'react-intl';
import styles from './DateAnnotationsModalItem.css?module';

class DateAnnotationsModalItem extends React.Component {
  render() {
    const {dateAnnotation} = this.props;

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <AvatarNamed userId={dateAnnotation.userId} />
          <span className={styles.createdDate}>
            <FormattedDate
              value={new Date(dateAnnotation.createdDate)}
              year="numeric"
              month="short"
              day="numeric"
            />
          </span>
        </div>
        <div className={styles.content}>{dateAnnotation.content}</div>
        <div className={styles.footer}>
          <Link
            className={styles.buzzLink}
            href={`/m/buzz/channel/${dateAnnotation.threadId}`}
          >
            <FormattedMessage
              id="DateAnnotationsModalItem__LinkToBuzzChannel"
              defaultMessage="Open in Buzz"
              description="Link to take the user directly to the buzz channel."
            />
          </Link>
        </div>
      </div>
    );
  }
}

DateAnnotationsModalItem.propTypes = {
  dateAnnotation: PropTypes.object.isRequired,
};

export default DateAnnotationsModalItem;
